module.exports = __webpack_public_path__ + "static/media/FutureView.c8a81e2f.jpg";